import { BaseDto } from "src/dtos/common/baseDto";

export interface CustomerDto extends BaseDto {
	customCd: string;
	customNm: string;
	customNmFull: string;
	areaCd: string;
	customType: string;
	owner: string;
	regNo: string;
	businessType: string;
	businessClass: string;
	moneyCd: string;
	telNo: string;
	faxNo: string;
	taxEmail: string;
	taxTelNo: string;
	post: string;
	address: string;
	detailAddress: string;
	remark: string;
	inserted: boolean;
	isModified: boolean;
}

export const defaultCustomerDto: CustomerDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	customCd: '',
	customNm: '',
	customNmFull: '',
	areaCd: '',
	customType: '',
	owner: '',
	regNo: '',
	businessType: '',
	businessClass: '',
	moneyCd: '',
	telNo: '',
	faxNo: '',
	taxEmail: '',
	taxTelNo: '',
	post: '',
	address: '',
	detailAddress: '',
	remark: '',
	inserted: false,
	isModified: false,
};
